import { createClient } from '@supabase/supabase-js';

// Get environment variables
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || '';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || '';

const isMissing = !supabaseUrl || !supabaseAnonKey;

if (isMissing) {
  console.warn('Missing Supabase Environment Variables. Dashboard auth will not work.');
}

// Use a placeholder URL if env vars are missing to prevent crash on landing page
// Auth features simply won't work, but the page will still render
export const supabase = createClient(
  supabaseUrl || 'https://placeholder.supabase.co',
  supabaseAnonKey || 'placeholder-key',
  {
    auth: {
      persistSession: !isMissing,
      autoRefreshToken: !isMissing,
      storageKey: 'jobisa-recruiter-auth',
      storage: window.localStorage,
    },
  }
);
